// extracted by mini-css-extract-plugin
export default {"btn":"AddToFavoriteBtn_btn__uQV8C","on":"AddToFavoriteBtn_on__w4Ri9","off":"AddToFavoriteBtn_off__X47i8"};